export const WHITE_SYSTEM_CODES = [
  'customer', // 货主系统
  'otms', // OTMS系统
  'wms2.0', // WMS系统
  'wms', // WMS1.0系统
  'storage-wms', // WES系统
  'wms_store', // 仓运营
  'fms', // FMS系统
  'NETWORK_FREIGHT', // 网络货运平台
  'audit', // BMS系统
  'otms-base', // 权限系统
  'carriers_bid', // 承运商招投标系统
  'csi', // 情报系统
  'dc_eam', // WES
  'wms_ws', // 仓供应端
  'wms_wsf', // 仓供应端完整版
  'wms_cwp', // 仓供应端
  'eam_admin', // 资产管理
];

export const BLACK_SYSTEM_CODES = [];
